import "./ResightingAssignments.css";
import { useState } from "react";
import { Collapse } from "@mui/material";
import { FiChevronDown } from "react-icons/fi";
import ResightingAssignmentTimeline from "./ResightingAssignmentTimeline";

function getActivitySummary({ isLoading, errorMessage, logCount }) {
  if (isLoading) {
    return "Loading…";
  }
  if (errorMessage) {
    return "Unable to load";
  }
}

function ResightingActivitySection({
  logs,
  isLoading,
  errorMessage,
  defaultExpanded = false,
}) {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const logCount = logs?.length ?? 0;
  const summary = getActivitySummary({ isLoading, errorMessage, logCount });

  return (
    <section className="resighting-qc-card resighting-log-timeline-section" style={{ padding: "0"}}>
      <button
        type="button"
        className="resighting-log-timeline-toggle"
        onClick={() => setExpanded((prev) => !prev)}
        aria-expanded={expanded}
        aria-controls="resighting-activity-panel"
        id="resighting-activity-toggle"
      >
        <span className="resighting-log-timeline-toggle-text">
          <span className="resighting-log-timeline-section-title">Audit Log</span>
          {!expanded ? (
            <span className="resighting-log-timeline-toggle-summary">{summary}</span>
          ) : null}
        </span>
        <FiChevronDown
          className={`resighting-log-timeline-chevron${expanded ? " resighting-log-timeline-chevron--expanded" : ""}`}
          size={20}
          aria-hidden="true"
        />
      </button>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <div
          id="resighting-activity-panel"
          role="region"
          aria-labelledby="resighting-activity-toggle"
          className="resighting-log-timeline-panel"
        >
          <ResightingAssignmentTimeline
            logs={logs}
            isLoading={isLoading}
            errorMessage={errorMessage}
          />
        </div>
      </Collapse>
    </section>
  );
}

export default ResightingActivitySection;
